var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMinhaConta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2D6C68BD-C801-4648-9036-C699B1560D4E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.home-aba/concursos",
    transform: "translate(-1162.000000, -28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-minha-conta",
    transform: "translate(1162.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#94D05E",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,14 C18.6887547,14 20.8818181,16.1223067 20.9953805,18.7831104 L21,19 L21,21 C21,21.5522847 20.5522847,22 20,22 C19.4871642,22 19.0644928,21.6139598 19.0067277,21.1166211 L19,21 L19,19 C19,17.4023191 17.75108,16.0963391 16.1762728,16.0050927 L16,16 L8,16 C6.40231912,16 5.09633912,17.24892 5.00509269,18.8237272 L5,19 L5,21 C5,21.5522847 4.55228475,22 4,22 C3.48716416,22 3.06449284,21.6139598 3.00672773,21.1166211 L3,21 L3,19 C3,16.3112453 5.12230671,14.1181819 7.78311038,14.0046195 L8,14 L16,14 Z",
    id: "Path",
    fill: "#1717CE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C9.23857625,2 7,4.23857625 7,7 C7,9.76142375 9.23857625,12 12,12 C14.7614237,12 17,9.76142375 17,7 C17,4.23857625 14.7614237,2 12,2 Z M12,4 C13.6568542,4 15,5.34314575 15,7 C15,8.65685425 13.6568542,10 12,10 C10.3431458,10 9,8.65685425 9,7 C9,5.34314575 10.3431458,4 12,4 Z",
    id: "Oval",
    fill: "#1717CE",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMinhaConta);
export default __webpack_public_path__ + "static/media/ic-minha-conta.76db2367b242f7199f8992452fe96660.svg";
export { ForwardRef as ReactComponent };